import React from "react";
import Headerdash from "./head";
import Sidebar from "./sidebar";
import { useState, useEffect } from "react";
import PageNavigation from "./page";

// Fetching Data from the API]

// End

// Page Html
export default function SummarizeSpokenText() {
  const [resourceData, setResourceData] = useState({
    data: [],
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/api/questions/summarizespokentext", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();

          setResourceData({
            data: data,
          });

          console.log("Data:", data);
        } else {
          console.error(
            "Failed to fetch SummarizeSpokenText data. Status:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error fetching SummarizeSpokenText data:", error);
      } finally {
        setLoading(false); // Set loading to false regardless of success or failure
      }
    };

    fetchData();
  }, []); // Empty dependency array to fetch data only once on mount

  // End

  return (
    <div>
      <Headerdash />
      <Sidebar />
      <PageNavigation heading="Summarize Spoken Text" id={resourceData.data} />

    </div>
  );
}
